export const stripDoubleSpaces = (str = '') =>
    !str.length ? str : str.replace(/\s\s+/g, ' ').trim()

export const stripDoubleSpacesTrimStart = (str = '') =>
    !str.length ? str : str.replace(/\s\s+/g, ' ').trimStart()

export const escapeRegExp = (str = '') =>
    str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
